import axios from 'axios';
import { httpClient, ROOT_URL } from '../App';

export async function getUserWallet() {
  return httpClient.get(`${ROOT_URL}/api/v1/blockchain/wallet`);
}

export async function getVTBalance() {
  return httpClient.get(`${ROOT_URL}/api/v1/virtual-tokens`);
}

export async function getETHPrice() {
  return axios.get('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=ETH,USD,EUR');
}
